module.exports = __webpack_public_path__ + "static/media/HOW TO ADD MULTIPLE VISA COUNTRIES IN EZYMIGRATE SYSTEM.83ede6bc.png";